module.exports = __webpack_public_path__ + "img/send-message--green.b92cefba.svg";